<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="serType">
      <van-dropdown-menu class="serTypeBar" active-color="#E32119">
        <van-dropdown-item v-model="search.sort" :options="optionSort" @change="selectTypeClose" />
        <van-dropdown-item v-model="search.course" :options="optionCourse" @change="selectTypeClose" />
      </van-dropdown-menu>
    </div>
    <div class="listBody">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.id" class="commodity" @click="inCommodity(item.id)">
          <van-row>
            <van-col span="7"><img class="icon" :src="item.icon"></van-col>
            <van-col span="1" />
            <van-col span="16">
              <span class="pageTitle1 title">{{ item.title }}</span><br>
              <div class="downRect"><span class="price">￥{{ item.lowPrice }}</span><span class="pagebody2 aboutStr">月售{{ item.sellNum }} | 评价{{ item.commentNum }}</span></div>
            </van-col>
          </van-row>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey } from '@/utils/base'
import { DropdownMenu, DropdownItem, List } from 'vant'
export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      title: '潜水中心',
      backurl: '/store/index',
      offsetTop: 0,
      loading: false,
      finished: false,
      list: [],
      search: {
        shopId: undefined,
        sort: 'BASE',
        course: '',
        limit: 30,
        page: 1,
        divecenter: undefined
      },
      optionSort: [
        { text: '推荐排序', value: 'BASE' },
        { text: '价格最低', value: 'LOW' },
        { text: '价格最高', value: 'HIGH' },
        { text: '销量最高', value: 'SELL' },
        { text: '好评最多', value: 'COMMENT' }
      ],
      optionCourse: [
        { text: '全部课程', value: '' },
        { text: '水肺课程', value: 'Diving Program' },
        { text: '自由潜课程', value: 'Freediving Program' }
      ]
    }
  },
  activated() {
    initPage(false)
    // keep-alive组件 页面进入的时候设置滚动高度
    document.documentElement.scrollTop = this.offsetTop
    console.log('activated', this.offsetTop)
  },
  beforeRouteLeave(to, from, next) {
    // keep-alive 组件停用时调用（简单理解为组件离开的时候）。
    // 获取页面滚动高度，这个钩子有可能会拿不到数据，因为这个钩子执行的慢，可以用beforeRouteLeave代替
    console.log('beforeRouteLeave', this.offsetTop)
    this.offsetTop = document.documentElement.scrollTop
    next()
  },
  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.search.shopId = parseInt(this.$route.params.id)
    this.title = '潜水中心'
    this.list = []
    this.onLoadName()
    this.onLoad()
  },
  methods: {
    onLoadName() {
      this.loading = true
      request({
        url: '/Store/getShopName',
        method: 'post',
        params: { id: this.search.shopId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.title = response.data
      })
    },
    onLoad() {
      this.loading = true
      request({
        url: '/Store/getOneShopCommodityList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    selectTypeClose() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    inCommodity(id) {
      this.$router.replace('/store/commodity/' + id + '?backurl=/store/commodityList/' + this.search.shopId)
    }
  }
}
</script>
<style scoped>
.serType{
    background-color: #fff;
    position: fixed;
    left: 0;
    top:3em;
    height: 3em;
    width: 100%;
    z-index: 10;
}
.serType .serTypeBar{
  width: calc(100% - 2em);
  left: 1em;
}
.listBody{
  margin-top: 4em;
  padding: 0 1em;
}
.commodity{
    border-bottom: 1px solid #dadada;
    margin: 1em 0;
    padding-bottom: 1em;
    position: relative;
}
.commodity .icon{
    width: 100%;
}
.commodity .downRect{
    position: absolute;
    bottom: 1.2em;
    left: 33%;
    right: 0;
}
.commodity .downRect .price{
    color:#E32119;
    font-weight: 700;
    margin-right: 1.5em;
}
.commodity .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}

</style>
